import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Tooltip } from 'components/core/Tooltip';
import { Button } from 'components/core/Button';
import { Paragraph } from 'components/core/Typography';
import { Image } from 'components/core/Image';

import Info from 'assets/images/icons/info.svg';
import './FilterButtonWithTooltip.scss';

export const enhance = (WrappedComponent) => {
	const WithFilterClickHandler = (props) => {
		const handleFilterClick = () => {
			if (props.onClick) {
				props.onClick(props.type, props.selected ? null : props.value);
			}
		};
		return (
			<WrappedComponent
				{...props}
				handleFilterClick={handleFilterClick}
			/>
		);
	};
	return WithFilterClickHandler;
};

export function FilterButtonWithTooltip({
	icon,
	label,
	selected,
	handleFilterClick,
	secondaryText,
	tooltipContent,
	first = false
}) {
	return (
		<Button
			primary={false}
			className={classnames('filter-button', { selected, first })}
			onClick={handleFilterClick}
		>
			{!!icon && <span className="icon">{icon}</span>}

			<div className="text-container">
				<div className="title-tooltip-container">
					<span>
						<Paragraph size="small">{label}</Paragraph>
					</span>

					<Tooltip
						className='filter-button-tooltip'
						content={tooltipContent}
						clickOnMobile
						fillParentContainer="right"
						simpleButton
						as="div"
						tooltipShowing
						onFocus
					>
						<Image
							src={Info}
							alt="Info"
							height={20}
							width={20}
							className="info-icon"
						/>
					</Tooltip>
				</div>

				<span
					size="small"
					last
				>
					{secondaryText}
				</span>
			</div>
		</Button>
	);
}

FilterButtonWithTooltip.propTypes = {
	icon: PropTypes.node,
	label: PropTypes.node,
	handleFilterClick: PropTypes.func,
	selected: PropTypes.bool,
	tooltipContent: PropTypes.node,
};

export default enhance(FilterButtonWithTooltip);